import type { QueryClient } from '@tanstack/react-query';

/**
 * Query prefixes a payment on a booking touches. A first deposit reserves the
 * bike and moves the booking OPEN -> CONFIRMED, so the bike pickers, the unit
 * page, the bookings list and the customer page (whose tabs key on these same
 * list prefixes, plus `customer`) all change, not only the Till. Prefixes, not
 * imports: features never import each other (CLAUDE.md §4).
 */
const PREFIXES = [
  'bookings-to-receive',
  'till-session',
  'bookings',
  'units',
  'unit',
  'invoices',
  'customer',
] as const;

export function invalidateAfterBookingPayment(queryClient: QueryClient, bookingUid: string): void {
  void queryClient.invalidateQueries({ queryKey: ['booking', bookingUid] });
  void queryClient.invalidateQueries({ queryKey: ['booking-money', bookingUid] });
  for (const prefix of PREFIXES) {
    void queryClient.invalidateQueries({ queryKey: [prefix] });
  }
}
